import { Select } from "antd";
import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";

import { useCreateTenantCurrencySelectOptions } from "./useCreateTenantCurrencySelectOptions";

export const CreateTenantCurrencySelectSearchable = (props: SearchableSelectWrapperProps) => {
    const hookResult = useCreateTenantCurrencySelectOptions();

    if (hookResult.loading && !hookResult.options.length) {
        return <Select {...props} loading disabled size={props.size ?? "middle"} />;
    }

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.currency"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
